import { Button, toast } from "@kyan/ui";

import { useCancelRFQRequest } from "#/services/kyan/hooks/useCancelRFQRequest";

interface CancelRequestProps {
  orderId?: string;
}

export const CancelRfqRequest: React.FC<CancelRequestProps> = ({ orderId }) => {
  const { mutate, isPending } = useCancelRFQRequest({
    onSuccess: () => {
      toast.success({ title: "Rfq request cancelled" });
    },
    onError: (error) => {
      toast.error({
        title: "Error cancelling RFQ request",
        description: error.message,
      });
    },
  });

  const handleCancelOrder = () => {
    if (!orderId) {
      return;
    }

    mutate({ order_id: orderId });
  };

  return (
    <Button
      size="sm"
      variant="action"
      disabled={isPending}
      onClick={handleCancelOrder}
    >
      Cancel
    </Button>
  );
};
